module.exports = __webpack_public_path__ + "img/show_filtered_results_button.9df757ad.png";